// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu {
  position: relative;
  display: inline-block;
}

.user-menu-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  transition: all 0.2s;
}

.user-menu-button:hover {
  background: rgba(0, 0, 0, 0.05);
}

.user-menu-button svg {
  display: block;
}

.user-menu-dropdown {
  position: absolute;
  top: calc(100% + 20px);
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  overflow: hidden;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-menu-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.user-menu-title {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.user-menu-guest-text {
  font-weight: 500;
  color: #666;
  font-size: 13px;
}

.user-menu-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.user-menu-item {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
  font-size: 14px;
  transition: background 0.2s;
}

.user-menu-item:hover {
  background: #f5f5f5;
}

.user-menu-item svg {
  flex-shrink: 0;
  color: #666;
}

.user-menu-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 4px 0;
}

.user-menu-logout {
  color: #e74c3c;
}

.user-menu-logout svg {
  color: #e74c3c;
}

.user-menu-logout:hover {
  background: #fef5f5;
}
`, "",{"version":3,"sources":["webpack://./src/css/UserMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".user-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.user-menu-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  transition: all 0.2s;\n}\n\n.user-menu-button:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.user-menu-button svg {\n  display: block;\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 20px);\n  left: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  z-index: 1000;\n  overflow: hidden;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-menu-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.user-menu-title {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.user-menu-guest-text {\n  font-weight: 500;\n  color: #666;\n  font-size: 13px;\n}\n\n.user-menu-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.user-menu-item {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #333;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.user-menu-item:hover {\n  background: #f5f5f5;\n}\n\n.user-menu-item svg {\n  flex-shrink: 0;\n  color: #666;\n}\n\n.user-menu-divider {\n  height: 1px;\n  background: #f0f0f0;\n  margin: 4px 0;\n}\n\n.user-menu-logout {\n  color: #e74c3c;\n}\n\n.user-menu-logout svg {\n  color: #e74c3c;\n}\n\n.user-menu-logout:hover {\n  background: #fef5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
